module.exports = __webpack_public_path__ + "static/media/order_qty.61f3cc87.svg";